export function combineValues(...args) {
    const functions = args.slice(0, -1);
    const compute = args[args.length - 1];
    return (props) => {
        const values = functions.map((value) => value(props));
        return compute(...values, props);
    };
}
//# sourceMappingURL=combineValues.js.map